<template>
  <edit-sidebar class="editMeetingInfoList">
    <div class="part">
      <h2>{{ props.title }}</h2>
      <form class="sentry-masked-text" @submit.prevent="saveAndReturn">
        <transition-group name="fieldList">
          <app-list-input
            key="list"
            :field-data="fields"
            item="an objective"
            :name="props.name"
            :limit="255"
            :warn-limit="200"
            @capture="capture"
            @save="saveAndReturn"
          />
          <div key="actions" class="actions btn-pair">
            <button type="button" @click.prevent="back">Cancel</button>
            <button type="button" @click.prevent="saveAndReturn">Save</button>
          </div>
        </transition-group>
      </form>
    </div>
  </edit-sidebar>
</template>

<script setup>
import { ref, watch, getCurrentInstance, nextTick } from 'vue';
import AppListInput from '@/components/AppListInput';
import EditSidebar from '@/components/EditSidebar';
import utils from '../resources/utils.js';
import { useSidebarStore } from '@/store/pinia/sidebar';
import { useMeetingStore } from '@/store/pinia/meeting';

const props = defineProps(['field', 'name', 'title', 'extra']);
const sidebarStore = useSidebarStore();
const meetingStore = useMeetingStore();
const $meetingmanager = getCurrentInstance().appContext.config.globalProperties.$meetingmanager;

const fields = ref([]);

watch(
  () => props.field,
  (nv) => {
    fields.value = nv.value.map((v) => utils.desanitizeString(v));
  },
  { immediate: true, deep: true },
);

function capture(data) {
  fields.value = data;
}

function saveAndReturn(e) {
  if (e) {
    meetingStore.updateLocalMeetingInfo({ prop: props.name, value: fields.value || [] });

    let dataObj = {
      trigger: props.name,
    };
    dataObj[props.name] = fields.value;
    $meetingmanager.updateMeeting(dataObj);

    nextTick(() => {
      sidebarStore.finishedWithPane(props.extra);
    });
  }
}

function back() {
  sidebarStore.finishedWithPane(props.extra);
}
</script>
